// extracted by mini-css-extract-plugin
export default {"gridContainerImg":"gallerySlider_gridContainerImg__XXJLO"};